import { render } from "./PatientDme.vue?vue&type=template&id=161ecccf&ts=true"
import script from "./PatientDme.ts?vue&type=script&lang=ts&external"
export * from "./PatientDme.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__